import { render, staticRenderFns } from "./shopSplit.vue?vue&type=template&id=11426aee&scoped=true"
import script from "./shopSplit.vue?vue&type=script&lang=js"
export * from "./shopSplit.vue?vue&type=script&lang=js"
import style0 from "./shopSplit.vue?vue&type=style&index=0&id=11426aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11426aee",
  null
  
)

export default component.exports